import {useEventCallback} from 'usehooks-ts';
import {FONT_SIZE_OPTIONS} from '../../constants';
import {useState} from 'react';
import {IPluginHooks} from '../ToolbarPlugin/types';
import {TFontFormat} from './types';
import {EFormatIncreaseDecrease} from '../ToolbarPlugin/enums';
import {addPx, createUpdateFontSize} from '../ToolbarPlugin/utils';

export const useCustomFontFormatCommand = ({editor}: IPluginHooks) => {
    const [fontFormat, setFontFormat] = useState<TFontFormat>({
        fontSize: '14px',
        isBold: false,
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false
    });

    const update = createUpdateFontSize(editor);

    const handleFontSizeChange = useEventCallback((mode: EFormatIncreaseDecrease) => {
        const currentIndex = FONT_SIZE_OPTIONS.findIndex(
            item => addPx(item.value) === fontFormat?.fontSize
        );

        if (currentIndex === -1) {
            return;
        }

        let newIndex = currentIndex;

        if (
            mode === EFormatIncreaseDecrease.INCREASE &&
            currentIndex < FONT_SIZE_OPTIONS.length - 1
        ) {
            newIndex += 1;
        } else if (mode === EFormatIncreaseDecrease.DECREASE && currentIndex > 0) {
            newIndex -= 1;
        }

        if (newIndex !== currentIndex) {
            const newFontSize = FONT_SIZE_OPTIONS[newIndex].value;
            update(newFontSize);
        }
    });

    return {fontFormat, handleFontSizeChange, setFontFormat} as const;
};
